import { useEffect, useState } from "react";

const useDebounce = (val: string, delay: number = 400) => {
    const [debouncedVal, setDebouncedVal] = useState(val);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedVal(val);
        }, delay);

        return () => clearTimeout(timer);
    }, [delay, val]);

    return debouncedVal;
};

export default useDebounce;
